import { Button, TextArea } from '@calizahq/react-components-v2'
import { Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'

import { InputSelect } from '@/components'
import { useUserContext } from '@/context'
import blockReasonsMutations from '@/graphql/mutations/blockReasons.mutations'
import { useBlockReasons } from '@/hooks/useBlockReasons'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import { HierarchyType } from '@/types/BlockReasons'

type Props = {
  homeId: number
  refetchOnSuccess?(): void
  toggle: () => void
}

export const HomeBlockForm = ({ homeId, toggle, refetchOnSuccess }: Props) => {
  const { homeBlockReasons } = useBlockReasons()
  const options: Array<{
    label: string
    value?: number
  }> = homeBlockReasons.map((reason) => {
    return { label: reason.description, value: reason.id }
  })

  options.unshift({ label: 'Select Reason' })

  const { user } = useUserContext()

  const { mutate, isPending: isLoading } = useGraphqlMutation(blockReasonsMutations.addBlockReason, {
    onSuccess: () => {
      refetchOnSuccess && refetchOnSuccess()
      toggle()
    },
  })

  const handleSubmit = (values: FormValues) => {
    const data = {
      recordBlockReason: {
        blockReasonId: Number(values.reason),
        recordType: HierarchyType.HOME,
        recordId: homeId,
        userId: user?.id,
        notes: values.notes,
      },
    }
    mutate({ blockReason: data })
  }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={formSchema}>
      {() => {
        return (
          <Form className="flex w-full flex-row flex-wrap">
            <InputSelect
              className="mb-4 w-full"
              id="reason"
              label="Reason"
              name="reason"
              options={options}
            ></InputSelect>

            <TextArea className="mb-4 w-full" label="Notes" name="notes" />
            <Button
              className=" w-full bg-text-semantic-success"
              disabled={isLoading}
              isLoading={isLoading}
              type="submit"
            >
              Submit
            </Button>
          </Form>
        )
      }}
    </Formik>
  )
}

type FormValues = typeof initialValues

const initialValues = {
  reason: '',
  notes: '',
}

const formSchema = Yup.object({
  reason: Yup.string().required('Please select a reason'),
  notes: Yup.string().required('Please add some notes'),
})
